export const ItemTypes = {
  LABEL: 'label',
	//...
}
